module.exports = __webpack_public_path__ + "static/media/notebook.71cb5a5b.png";